import Select from 'meinian-package/src/baseComponent/select'
import TiledSelect from 'baseComponent/tiledSelect'
import { COMMON_PLATFORM_CONFIG_ENUM } from 'meinian-package/src/component/platformConfig'
import { useRequest } from 'ahooks'
import { request } from 'meinian-package/src/utils'

export default (props) => {
  const { value, onChange, placement, ulStyle, trigger } = props

  const { data = [] } = useRequest(async () => {
    const result = await request.get('/zhikuan/platform/mn-list-zk-platform')
    const platformOptions = COMMON_PLATFORM_CONFIG_ENUM.values().map(item => ({ ...item, value: String(item.value) }))
    return [...platformOptions, {
      label: '知款站点',
      value: result.map(item => item.platformId).join(',')
    }]
  })

  return <Select
    placement={placement}
    data={data}
    value={value}
    onChange={onChange}
    placeholder="款式来源"
    style={{ maxHeight: 'unset' }}
    ulStyle={ulStyle}
    trigger={trigger}
  />
}

export const TiledPlatform = ({ value, onChange, style, className }) => {
  const { data = [] } = useRequest(async () => {
    const result = await request.get('/zhikuan/platform/mn-list-zk-platform')
    const platformOptions = COMMON_PLATFORM_CONFIG_ENUM.values().map(item => ({ ...item, value: String(item.value) }))
    return [...platformOptions, {
      label: '知款站点',
      value: result.map(item => item.platformId).join(',')
    }]
  })

  return <TiledSelect
    label="款式来源"
    options={data}
    value={value}
    onChange={onChange}
    style={style}
    className={className}
  />
}
